import React from 'react';
import * as sc from './IconDiscord.style';

const IconDiscord = () => <sc.DiscordSvgg />;

export default IconDiscord;
